<app-layout [enableTopGap]="true">
  <section class="ab-hero">
    <div class="container">
      <h1
        class="ab-hero-title"
        [appSplitText]="'about.story.ourStory-title' | translate"
        splitMode="intro"
        splitDelay="0.1"
      ></h1>
    </div>
  </section>

  <section class="ab-story">
    <div class="container">
      <div class="ab-intro">
        <div class="ab-text">
          <p class="ab-lead" appReveal="rise">
            {{ "about.story.text" | translate }}
          </p>
          <h2 class="ab-title" [appSplitText]="'about.mission.mission-title' | translate" splitMode="reveal"></h2>
          <p appReveal="rise" revealDelay="0.1">
            {{ "about.mission.text" | translate }}
          </p>
        </div>
        <div class="ab-frame">
          <div class="ab-shape">
            <img
              srcset="assets/images/about/instructor-1600.jpg 1600w, assets/images/about/instructor-800.jpg 800w"
              sizes="(max-width: 991px) 100vw, 440px"
              src="assets/images/about/instructor-800.jpg"
              alt="instructor"
              width="1600"
              height="1067"
              decoding="async"
              [appParallax]="{ y: [-6, 6], trigger: 'parent' }"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="ab-why">
    <div class="container">
      <h2 class="ab-title" [appSplitText]="'about.chooseUs.title' | translate" splitMode="reveal"></h2>
      <ul class="ab-cards" role="list">
        <li class="ab-card" *ngFor="let item of whyChooseUs; trackBy: trackByIndex" appReveal="rise" revealBatch>
          <span class="ab-check" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="20" height="20" focusable="false">
              <path
                d="M4 12l5 5L20 6"
                stroke="#6950a1"
                stroke-width="2.5"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <div class="ab-card-body">
            <h3 class="option-title">{{ item.title }}</h3>
            <p>{{ item.describtion }}</p>
          </div>
        </li>
      </ul>
    </div>
  </section>
</app-layout>
